
$controllers.foldersettings = {
	
	onUnload : function() {
		$controllers.foldersettings.unbindEscapeKey();
	},
	
	display : function() {
		
		if (!$controllers.all.enforcePagePermissions('foldersettings')) { return false; }
		$controllers.all.showPage('foldersettings', 'contentpage');
		$controllers.all.setNavigation();
		$views.foldersettings.display();
		$controllers.foldersettings.handleEscapeKey();
		
	},
	
	handleEscapeKey : function() {
		jQuery('#folder_types').keyup(function(e) {
			var code = (e.keyCode ? e.keyCode : e.which);
			if (code == 27) {
				// cancel folder type edit
				$controllers.foldersettings.cancelEditFolderType();
			}
			if (code == 13) {
				// save folder type edit
				jQuery('#folder_types .edit_folder_type_button:visible').click();
			}
		});
		jQuery('#folder_statuses').keyup(function(e) {
			var code = (e.keyCode ? e.keyCode : e.which);
			if (code == 27) {
				// cancel folder status edit
				$controllers.foldersettings.cancelEditFolderStatus();
			}
			if (code == 13) {
				// save folder status edit
				jQuery('#folder_statuses .edit_folder_type_button:visible').click();
			}
		});
	},
	
	unbindEscapeKey : function() {
		jQuery('#folder_types').unbind('keyup');
		jQuery('#folder_statuses').unbind('keyup');
	},
	
	saveFolderType : function($id) {
		
		$name = jQuery('#folder_type_name').val();
		
		// quick validation
		if (!$name) {
			$soupmail.modal.error('Please ensure you enter a name');
			return false;
		}
		
		// init data
		$typeData = { folder_type: { name: $name } };
		
		// save type
		$models.foldertypes.setItem($id, $typeData, function() {
			$soupmail.notification.message('Folder type saved');
			jQuery('#folder_type_name').val('');
			$views.foldersettings.display();
		});
		
	},
	
	editFolderType : function($id) {
		
		$name = jQuery('#foldertype_'+$id+' #folder_type_edit_name').val();
		
		// quick validation
		if (!$name) {
			$soupmail.modal.error('Please ensure you enter a name');
			return false;
		}
		
		// init data
		$typeData = { folder_type: { name: $name } };
		
		// save type
		$models.foldertypes.setItem($id, $typeData, function() {
			$soupmail.notification.message('Folder type saved');
			jQuery('#foldertype_'+$id+' .foldertypes_type_name_edit').hide();
			jQuery('#foldertype_'+$id+' .foldertypes_type_name').html($name);
			jQuery('#foldertype_'+$id+' .foldertypes_type_name').show();
			jQuery('#foldertype_'+$id+' .edit-button').show();
		});
		
	},
	
	cancelEditFolderType : function() {
		jQuery('#folder_types .foldertypes_type_name_edit').hide();
		jQuery('#folder_types .foldertypes_type_name').show();
		jQuery('#folder_types .edit-button').show();
	},
	
	deleteFolderType : function($id) {
		
		$soupmail.modal.question('Are you sure you wish to remove this type?', function() {
			$models.foldertypes.deleteItem($id, function() {
				jQuery('#foldertype_'+$id).hide();
				$soupmail.notification.message('Folder type removed');
				$views.foldersettings.display();
				$controllers.all.setNavigation();
			});
		});
		
	},
	
	saveFolderStatus : function($id) {
		
		$name = jQuery('#folder_status_name').val();
		
		// quick validation
		if (!$name) {
			$soupmail.modal.error('Please ensure you enter a name');
			return false;
		}
		
		// init data
		$statusData = { folder_status: { name: $name } };
		
		// save status
		$models.folderstatuses.setItem($id, $statusData, function() {
			$soupmail.notification.message('Folder status saved');
			jQuery('#folder_status_name').val('');
			$views.foldersettings.display();
		});
		
	},
	
	editFolderStatus : function($id) {
		
		$name = jQuery('#folderstatus_'+$id+' #folder_status_edit_name').val();
		
		// quick validation
		if (!$name) {
			$soupmail.modal.error('Please ensure you enter a name');
			return false;
		}
		
		// init data
		$statusData = { folder_status: { name: $name } };
		
		// save status
		$models.folderstatuses.setItem($id, $statusData, function() {
			$soupmail.notification.message('Folder status saved');
			jQuery('#folderstatus_'+$id+' .folderstatuses_status_name_edit').hide();
			jQuery('#folderstatus_'+$id+' .folderstatuses_status_name').html($name);
			jQuery('#folderstatus_'+$id+' .folderstatuses_status_name').show();
			jQuery('#folderstatus_'+$id+' .edit-button').show();
		});
		
	},
	
	cancelEditFolderStatus : function() {
		jQuery('#folder_statuses .folderstatuses_status_name_edit').hide();
		jQuery('#folder_statuses .folderstatuses_status_name').show();
		jQuery('#folder_statuses .edit-button').show();
	},
	
	deleteFolderStatus : function($id) {
		
		$soupmail.modal.question('Are you sure you wish to remove this status?', function() {
			$models.folderstatuses.deleteItem($id, function() {
				jQuery('#folderstatus_'+$id).hide();
				$soupmail.notification.message('Folder status removed');
				$views.foldersettings.display();
				$controllers.all.setNavigation();
			});
		});
		
	}
	
};



// WEBPACK FOOTER //
// ./src/js/controllers/desktop.foldersettings.js